// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How many of a `ControlRoute`'s targets receive the write.
 *
 * Fan-out is a property of the individual rule, not of the channel, so one
 * control may go to a single endpoint while another is broadcast to every one.
 *
 * SINGLE (0) — ordered fallback. Targets are tried in `ordinal` order and the
 *              first reachable endpoint receives the write; the rest are
 *              skipped. Correct for physical actuation (`OpenDoor`, `RunUp`),
 *              where writing twice would actuate twice.
 * ALL (1)    — every active target receives the write. Only safe for commands
 *              that are idempotent across controllers (locks, secures).
 */
export enum ControlFanOut {
  SINGLE = 0,
  ALL = 1,
}
